export default {
  setRowCategories(state, rowCategories) {
    state.rowCategories = rowCategories;
  },
  setCurrentPage(state, currentPage) {
    state.currentPage = currentPage;
  },
  setPageCount(state, pageCount) {
    state.pageCount = pageCount;
  },
  setEditCategory(state, editCategory) {
    state.editCategory = editCategory;
  },
  setCategoryToEdit(state, category) {
    state.categoryToEdit = category;
  },
  setCategoryToDelete(state, category) {
    state.categoryToDelete = category;
  }
};
